
/* ----------------------------------------------------------------------
   No sticky header on phones.

   A sticky header costs the same strip of screen on every scroll, and on a
   phone that strip is a far bigger share of the page than it is on a desktop
   monitor. Below 750px it now scrolls away with the content; iPad and desktop
   keep it.

   Done by removing the attribute rather than only overriding the CSS, and
   done here rather than on DOMContentLoaded, because empire.js is loaded
   async: this inline script runs during parse, so Empire finds no
   `data-site-header-sticky` and never initialises sticky at all. Fighting it
   afterwards would mean undoing whatever spacer or body padding it had
   already added.

   The CSS override below is the belt to this braces. It covers the case this
   cannot: a window resized down after load, where Empire has already
   initialised and will not undo itself.
---------------------------------------------------------------------- */
(function () {
  try {
    var main = document.querySelector('[data-site-header-main]');
    if (!main) return;
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    /* Remember it so a reload at desktop width is unaffected - this only ever
       changes the live DOM, never the setting. */
    main.setAttribute('data-ll-sticky-off', '1');
    main.removeAttribute('data-site-header-sticky');

    /* Empire is not the only thing that can pin this. Some builds mark the
       section wrapper instead, and the theme's own CSS may carry
       position:sticky on it. Flag the wrappers so the stylesheet above has a
       hook, and strip any sticky data attributes it finds on the way up. */
    var node = main;
    for (var i = 0; i < 4 && node; i++) {
      node = node.parentElement;
      if (!node) break;
      if (node.hasAttribute && node.hasAttribute('data-site-header-sticky')) {
        node.removeAttribute('data-site-header-sticky');
      }
    }
  } catch (e) {}
})();

/* ----------------------------------------------------------------------
   Watchlist badge.

   Reads the shared `ll_watchlist` key and repaints on the same
   `ll:watchlist:change` event every other section fires, so a bell tapped
   on a product page, a hub, a collection or the deals strip updates the
   header immediately without a reload. The storage listener covers a second
   tab, and the sync snippet fires the same event when the account copy
   arrives, so a signed-in shopper landing on a new device sees the real
   number as soon as it syncs rather than a stale zero.

   Deliberately no Liquid-rendered count: for a guest the list exists only in
   their browser, and for a customer the account copy has not arrived at
   render time. Either way Liquid would print the wrong number first.
---------------------------------------------------------------------- */
(function () {
  if (window.__llHeaderWatchBooted) return;
  window.__llHeaderWatchBooted = true;

  var KEY = 'll_watchlist';
  var LEGACY = 'll_preorder_watch';

  function boot() {
    var box = document.querySelector('[data-ll-header-watch]');
    if (!box) return;
    var num = box.querySelector('[data-ll-header-watch-count]');
    var sr = box.querySelector('[data-ll-header-watch-sr]');

    function read() {
      try {
        var raw = localStorage.getItem(KEY);
        if (raw == null) raw = localStorage.getItem(LEGACY);
        var list = raw ? JSON.parse(raw) : [];
        if (Object.prototype.toString.call(list) !== '[object Array]') return 0;
        /* De-duplicate defensively: an older section could have written a
           list with repeats, and a count that disagrees with the page the
           badge links to is worse than no badge. */
        var seen = {}, n = 0;
        for (var i = 0; i < list.length; i++) {
          var h = String(list[i] || '').trim();
          if (!h || seen[h]) continue;
          seen[h] = 1;
          n++;
        }
        return n;
      } catch (e) { return 0; }
    }

    function paint() {
      var n = read();
      box.setAttribute('data-count', String(n));
      box.hidden = n < 1;
      if (num) num.textContent = n > 99 ? '99+' : String(n);
      if (sr) {
        sr.textContent = n === 1
          ? 'Your watchlist, 1 item'
          : 'Your watchlist, ' + n + ' items';
      }
    }

    /* ------------------------------------------------------------------
       Publish the right cluster's real width.

       .site-header-right is absolutely positioned above 769px, so the row
       keeps clear of it with padding rather than layout. That padding has to
       match a width that genuinely varies: "Join free" is wider than a
       returning customer's name, the wording hides at 1180px, and this badge
       appears only once the list has something in it. Measuring beats every
       fixed number we could pick.
    ------------------------------------------------------------------ */
    var right = document.querySelector('.site-header-right');
    var main = document.querySelector('.site-header-main');
    function measure() {
      if (!right || !main) return;
      var w = Math.ceil(right.getBoundingClientRect().width);
      if (w > 0) main.style.setProperty('--ll-right-w', w + 'px');
    }

    function refresh() { paint(); measure(); }

    refresh();
    document.addEventListener('ll:watchlist:change', refresh);
    window.addEventListener('storage', function (e) {
      if (!e || e.key === KEY || e.key === LEGACY) refresh();
    });
    window.addEventListener('resize', measure);
    /* Fonts land after first paint and change the account text width. */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    if (window.ResizeObserver && right) new ResizeObserver(measure).observe(right);
    /* The sync snippet may resolve the account list slightly after load. */
    setTimeout(refresh, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
